import _cloneDeep from 'lodash-es/cloneDeep';
import { SearchUtils } from "./SearchUtils";
import { ITextCode } from 'libraries/service/resources/model/search/ITextCode';
import { IDateRange } from 'libraries/service/resources/model/search/IDateRange';
import {
    BookingSearchParameters as EBookingSearchParameters,
    BookingSearchParametersShortName,
    IBookingSearchParameters,
    IBookingSearchParametersURL
} from 'libraries/interfaces/IBookingSearchParameters';
import { DatesService } from "app_sasha/shared/services/dates/dates.service";
import { Yii } from "libraries/interfaces/Yii";
import { IAfidiumServicePatchedValue } from "app_sasha/shared/models/search-utils.service";
import { Injectable } from "@angular/core";

export interface IConfig {
    name: string;
    shortName: string;
}
export interface IConfigFormArray {
    name: string;
    shortName: string;
    type: string;
    displayValue: string;
}

@Injectable()
export class BookingSearchParameters implements IBookingSearchParameters {
    public static DEFAULT_PAGINATION_NUMBER: number = 50;

    public static STRING_PROPERTIES: IConfig[] = [
        { name: EBookingSearchParameters.pendingValueMin, shortName: BookingSearchParametersShortName.pendingValueMin },
        { name: EBookingSearchParameters.pendingValueMax, shortName: BookingSearchParametersShortName.pendingValueMax },
        { name: EBookingSearchParameters.pendingPercentageMin, shortName: BookingSearchParametersShortName.pendingPercentageMin },
        { name: EBookingSearchParameters.pendingPercentageMax, shortName: BookingSearchParametersShortName.pendingPercentageMax },
        { name: EBookingSearchParameters.paidValueMin, shortName: BookingSearchParametersShortName.paidValueMin },
        { name: EBookingSearchParameters.paidValueMax, shortName: BookingSearchParametersShortName.paidValueMax },
        { name: EBookingSearchParameters.paidPercentageMin, shortName: BookingSearchParametersShortName.paidPercentageMin },
        { name: EBookingSearchParameters.paidPercentageMax, shortName: BookingSearchParametersShortName.paidPercentageMax },
        { name: EBookingSearchParameters.dueValueMin, shortName: BookingSearchParametersShortName.dueValueMin },
        { name: EBookingSearchParameters.dueValueMax, shortName: BookingSearchParametersShortName.dueValueMax },
        { name: EBookingSearchParameters.duePercentageMin, shortName: BookingSearchParametersShortName.duePercentageMin },
        { name: EBookingSearchParameters.duePercentageMax, shortName: BookingSearchParametersShortName.duePercentageMax },
        { name: EBookingSearchParameters.savingMin, shortName: BookingSearchParametersShortName.savingMin },
    ];
    public static PERCENTAGE_PROPERTIES: IConfig[] = [
        { name: EBookingSearchParameters.pendingPercentageMin, shortName: BookingSearchParametersShortName.pendingPercentageMin },
        { name: EBookingSearchParameters.pendingPercentageMax, shortName: BookingSearchParametersShortName.pendingPercentageMax },
        { name: EBookingSearchParameters.paidPercentageMin, shortName: BookingSearchParametersShortName.paidPercentageMin },
        { name: EBookingSearchParameters.paidPercentageMax, shortName: BookingSearchParametersShortName.paidPercentageMax },
        { name: EBookingSearchParameters.duePercentageMin, shortName: BookingSearchParametersShortName.duePercentageMin },
        { name: EBookingSearchParameters.duePercentageMax, shortName: BookingSearchParametersShortName.duePercentageMax },
    ];
    public static NUMBER_PROPERTIES: IConfig[] = [
        { name: EBookingSearchParameters.pendingValueMin, shortName: BookingSearchParametersShortName.pendingValueMin },
        { name: EBookingSearchParameters.pendingValueMax, shortName: BookingSearchParametersShortName.pendingValueMax },
        { name: EBookingSearchParameters.paidValueMin, shortName: BookingSearchParametersShortName.paidValueMin },
        { name: EBookingSearchParameters.paidValueMax, shortName: BookingSearchParametersShortName.paidValueMax },
        { name: EBookingSearchParameters.dueValueMin, shortName: BookingSearchParametersShortName.dueValueMin },
        { name: EBookingSearchParameters.dueValueMax, shortName: BookingSearchParametersShortName.dueValueMax },
        { name: EBookingSearchParameters.savingMin, shortName: BookingSearchParametersShortName.savingMin },
    ];

    public static STRING_ARRAY_PROPERTIES: IConfig[] = [
        { name: EBookingSearchParameters.text, shortName: BookingSearchParametersShortName.text },
        { name: EBookingSearchParameters.code, shortName: BookingSearchParametersShortName.code },
        { name: EBookingSearchParameters.agency, shortName: BookingSearchParametersShortName.agency },
        { name: EBookingSearchParameters.agent, shortName: BookingSearchParametersShortName.agent },
        { name: EBookingSearchParameters.xStatus, shortName: BookingSearchParametersShortName.xStatus },
        { name: EBookingSearchParameters.xType, shortName: BookingSearchParametersShortName.xType },
        { name: EBookingSearchParameters.midOffice, shortName: BookingSearchParametersShortName.midOffice },
        { name: EBookingSearchParameters.seatStatus, shortName: BookingSearchParametersShortName.seatStatus },
        { name: EBookingSearchParameters.person, shortName: BookingSearchParametersShortName.person },
        { name: EBookingSearchParameters.host, shortName: BookingSearchParametersShortName.host },
        { name: EBookingSearchParameters.type, shortName: BookingSearchParametersShortName.type },
        { name: EBookingSearchParameters.issueStatus, shortName: BookingSearchParametersShortName.issueStatus },
        { name: EBookingSearchParameters.retentionReason, shortName: BookingSearchParametersShortName.retentionReason },
        { name: EBookingSearchParameters.sectorSeatStatus, shortName: BookingSearchParametersShortName.sectorSeatStatus },
        { name: EBookingSearchParameters.sectorFlightNumber, shortName: BookingSearchParametersShortName.sectorFlightNumber },
        { name: EBookingSearchParameters.pricingRate, shortName: BookingSearchParametersShortName.pricingRate },
        { name: EBookingSearchParameters.pricingXState, shortName: BookingSearchParametersShortName.pricingXState },
        { name: EBookingSearchParameters.pricingFarebasis, shortName: BookingSearchParametersShortName.pricingFarebasis },
        { name: EBookingSearchParameters.documentTicket, shortName: BookingSearchParametersShortName.documentTicket },
        { name: EBookingSearchParameters.serviceCode, shortName: BookingSearchParametersShortName.serviceCode },
        { name: EBookingSearchParameters.serviceXStatus, shortName: BookingSearchParametersShortName.serviceXStatus },
        { name: EBookingSearchParameters.system, shortName: BookingSearchParametersShortName.system },
        { name: EBookingSearchParameters.systemAgency, shortName: BookingSearchParametersShortName.systemAgency },
        { name: EBookingSearchParameters.remarkText, shortName: BookingSearchParametersShortName.remarkText },
        { name: EBookingSearchParameters.remarkRemark, shortName: BookingSearchParametersShortName.remarkRemark },
        { name: EBookingSearchParameters.remarkNote, shortName: BookingSearchParametersShortName.remarkNote },
        { name: EBookingSearchParameters.remarkInvoicing, shortName: BookingSearchParametersShortName.remarkInvoicing },
        { name: EBookingSearchParameters.remarkOsi, shortName: BookingSearchParametersShortName.remarkOsi },
        { name: EBookingSearchParameters.remarkVendorAlert, shortName: BookingSearchParametersShortName.remarkVendorAlert },

        { name: EBookingSearchParameters.ticketFlightNumber, shortName: BookingSearchParametersShortName.ticketFlightNumber },
        { name: EBookingSearchParameters.ticketStatus, shortName: BookingSearchParametersShortName.ticketStatus },
        { name: EBookingSearchParameters.ticketNativeStatus, shortName: BookingSearchParametersShortName.ticketNativeStatus },

        { name: EBookingSearchParameters.placesToStay, shortName: BookingSearchParametersShortName.placesToStay },
        { name: EBookingSearchParameters.propertyName, shortName: BookingSearchParametersShortName.propertyName },
        { name: EBookingSearchParameters.propertyReference, shortName: BookingSearchParametersShortName.propertyReference },

        { name: EBookingSearchParameters.actionForFareOptimisation, shortName: BookingSearchParametersShortName.actionForFareOptimisation },
        { name: EBookingSearchParameters.impactOnFareType, shortName: BookingSearchParametersShortName.impactOnFareType },
        { name: EBookingSearchParameters.impactOnLuggage, shortName: BookingSearchParametersShortName.impactOnLuggage },

        { name: EBookingSearchParameters.qualityCheck, shortName: BookingSearchParametersShortName.qualityCheck },
        { name: EBookingSearchParameters.hasMembershipCard, shortName: BookingSearchParametersShortName.hasMembershipCard },
        { name: EBookingSearchParameters.hasSeatAssignment, shortName: BookingSearchParametersShortName.hasSeatAssignment },

    ];

    public static CODE_TEXT_PROPERTIES: IConfig[] = [
        { name: EBookingSearchParameters.from, shortName: BookingSearchParametersShortName.from },
        { name: EBookingSearchParameters.to, shortName: BookingSearchParametersShortName.to },
        { name: EBookingSearchParameters.carrier, shortName: BookingSearchParametersShortName.carrier },
        { name: EBookingSearchParameters.sectorCarrier, shortName: BookingSearchParametersShortName.sectorCarrier },
        { name: EBookingSearchParameters.sectorOperatingCarrier, shortName: BookingSearchParametersShortName.sectorOperatingCarrier },
        { name: EBookingSearchParameters.sectorFrom, shortName: BookingSearchParametersShortName.sectorFrom },
        { name: EBookingSearchParameters.sectorTo, shortName: BookingSearchParametersShortName.sectorTo },
        { name: EBookingSearchParameters.location, shortName: BookingSearchParametersShortName.location },

        { name: EBookingSearchParameters.ticketSectorFrom, shortName: BookingSearchParametersShortName.ticketSectorFrom },
        { name: EBookingSearchParameters.ticketSectorTo, shortName: BookingSearchParametersShortName.ticketSectorTo },
        { name: EBookingSearchParameters.ticketSectorCarrier, shortName: BookingSearchParametersShortName.ticketSectorCarrier },
    ];

    public static DATE_RANGE_PROPERTIES: IConfig[] = [
        { name: EBookingSearchParameters.whenCreated, shortName: BookingSearchParametersShortName.whenCreated },
        { name: EBookingSearchParameters.whenAgencyBookingCreated, shortName: BookingSearchParametersShortName.whenAgencyBookingCreated },
        { name: EBookingSearchParameters.whenLastUpdated, shortName: BookingSearchParametersShortName.whenLastUpdated },
        { name: EBookingSearchParameters.whenIssued, shortName: BookingSearchParametersShortName.whenIssued },
        { name: EBookingSearchParameters.whenToIssue, shortName: BookingSearchParametersShortName.whenToIssue },
        { name: EBookingSearchParameters.begin, shortName: BookingSearchParametersShortName.begin },
        { name: EBookingSearchParameters.end, shortName: BookingSearchParametersShortName.end },
        { name: EBookingSearchParameters.whenTravelReallyBegins, shortName: BookingSearchParametersShortName.whenTravelReallyBegins },
        { name: EBookingSearchParameters.sectorBeginDate, shortName: BookingSearchParametersShortName.sectorBeginDate },
        { name: EBookingSearchParameters.sectorArrivalDate, shortName: BookingSearchParametersShortName.sectorArrivalDate },
        { name: EBookingSearchParameters.whenOptionDrops, shortName: BookingSearchParametersShortName.whenOptionDrops },
        { name: EBookingSearchParameters.whenRetentionEnds, shortName: BookingSearchParametersShortName.whenRetentionEnds },
        { name: EBookingSearchParameters.ticketSectorBeginDate, shortName: BookingSearchParametersShortName.ticketSectorBeginDate },
        { name: EBookingSearchParameters.stayBeginDate, shortName: BookingSearchParametersShortName.stayBeginDate },
        { name: EBookingSearchParameters.stayArrivalDate, shortName: BookingSearchParametersShortName.stayArrivalDate },
    ];

    public static BOOLEAN_PROPERTIES: IConfig[] = [
        { name: EBookingSearchParameters.sectorMatchAll, shortName: BookingSearchParametersShortName.sectorMatchAll },
        { name: EBookingSearchParameters.ticketMatchAll, shortName: BookingSearchParametersShortName.ticketMatchAll },
        { name: EBookingSearchParameters.hasFareOptimisation, shortName: BookingSearchParametersShortName.hasFareOptimisation },
    ];

    public static AFIDIUM_SERVICE_PROPERTIES: IConfigFormArray[] = [
        {
            name: EBookingSearchParameters.serviceCodes,
            shortName: BookingSearchParametersShortName.serviceCodes,
            type: 'string',
            displayValue: Yii.t('wui-shared-js', "Service selectionné"),
        },
        {
            name: EBookingSearchParameters.eligibilityStatuses,
            shortName: BookingSearchParametersShortName.eligibilityStatuses,
            type: 'string',
            displayValue: Yii.t('wui-shared-js', "Statut d'éligibilité"),
        },
        {
            name: EBookingSearchParameters.operationStatuses,
            shortName: BookingSearchParametersShortName.operationStatuses,
            type: 'string',
            displayValue: Yii.t('wui-shared-js', "Statut de traitement"),
        },
        {
            name: EBookingSearchParameters.whenExecutedOperation,
            shortName: BookingSearchParametersShortName.whenExecutedOperation,
            type: 'date',
            displayValue: Yii.t('wui-shared-js', "Date de traitement"),
        },
    ];

    public text?: string[];
    public code?: string[];
    public agency?: string[];
    public agent?: string[];
    public xStatus?: string[];
    public xType?: string[];
    public midOffice?: string[];
    public person?: string[];
    public host?: string[];
    public seatStatus?: string[];
    public issueStatus?: string[];
    public retentionReason?: string[];
    public from?: ITextCode;
    public to?: ITextCode;
    public carrier?: ITextCode;
    public whenCreated?: IDateRange;
    public whenLastUpdated?: IDateRange;
    public whenIssued?: IDateRange;
    public whenToIssue?: IDateRange;
    public whenOptionDrops?: IDateRange;
    public whenRetentionEnds?: IDateRange;
    public begin?: IDateRange;
    public end?: IDateRange;
    public whenTravelReallyBegins?: IDateRange;
    public sectorSeatStatus?: string[];
    public sectorCarrier?: ITextCode;
    public sectorOperatingCarrier?: ITextCode;
    public sectorFrom?: ITextCode;
    public sectorTo?: ITextCode;
    public sectorBeginDate?: IDateRange;
    public sectorArrivalDate?: IDateRange;
    public location?: ITextCode;
    public documentTicket?: string[];
    public pricingRate?: string[];
    public pricingXState?: string[];
    public pricingFarebasis?: string[];
    public serviceCode?: string[];
    public serviceXStatus?: string[];
    public system?: string;
    public systemAgency?: string;
    public form?: boolean;
    public afidiumServices?: IAfidiumServicePatchedValue[];

    //ticket
    public ticketMatchAll?: boolean;
    public ticketSectorFrom?: ITextCode;
    public ticketSectorTo?: ITextCode;
    public ticketSectorBeginDate?: IDateRange;
    public ticketFlightNumber?: string[];
    public ticketStatus?: string[];
    public ticketNativeStatus?: string[];
    public ticketSectorCarrier: ITextCode;

    // FareOpt
    public actionForFareOptimisation?: string[];
    public impactOnLuggage?: string[];
    public impactOnFareType?: string[];

    // QualityCheck
    public qualityCheck?: string[];

    //treatment
    public status: string[];
    public type: string[];

    public nbrecord: number;
    public first: number = 1;


    constructor() {
        this.nbrecord = BookingSearchParameters.DEFAULT_PAGINATION_NUMBER;
    }

    /**
     * @param routeParams parameters to extract
     * @param datesService has to be provided if date expression support is required, otherwise can be omited
     */
    public static fromRouteParams(routeParams: IBookingSearchParametersURL, datesService?: DatesService): BookingSearchParameters {
        const newParams: BookingSearchParameters = new BookingSearchParameters();

        BookingSearchParameters.STRING_ARRAY_PROPERTIES
            .forEach((config: IConfig) => {
                newParams[config.name] = SearchUtils.getStringArrayValue<IBookingSearchParametersURL>(routeParams, config.shortName);
            });

        BookingSearchParameters.STRING_PROPERTIES
            .forEach((config: IConfig): void => {
                newParams[config.name] = SearchUtils.getNumberValue<IBookingSearchParametersURL>(routeParams, config.shortName);
                });

        BookingSearchParameters.CODE_TEXT_PROPERTIES
            .forEach((config: IConfig) => {
                newParams[config.name] = SearchUtils.getTextCodeValue<IBookingSearchParametersURL>(routeParams, config.shortName);
            });

        BookingSearchParameters.DATE_RANGE_PROPERTIES
            .forEach((config: IConfig) => {
                newParams[config.name] = SearchUtils.getDateRangeValue<IBookingSearchParametersURL>(routeParams, config.shortName, datesService);
            });

        BookingSearchParameters.BOOLEAN_PROPERTIES
            .forEach((config: IConfig) => {
                newParams[config.name] = SearchUtils.getBooleanValue<IBookingSearchParametersURL>(routeParams, config.shortName);
            });

        newParams.nbrecord = routeParams.nbrecord || 20;
        newParams.first = routeParams.first || 1;

        return newParams;
    }

    public static fromRouteParamsAfidiumService(queryParams: IBookingSearchParametersURL, shortName: string): IAfidiumServicePatchedValue[] {
        const allAfidiumServices: IAfidiumServicePatchedValue[] = [];
        const maxServiceIndex: number = BookingSearchParameters.extractMaxIndexNumber(queryParams, shortName);

        for (let index: number = 0; index <= maxServiceIndex; index++) {
            const afidiumService: {} = {};
            BookingSearchParameters.AFIDIUM_SERVICE_PROPERTIES.forEach((propertyItem: IConfigFormArray) => {
                if (propertyItem.type === 'string') {
                    if (queryParams[BookingSearchParameters.getIndexedParamName(shortName, index, propertyItem.shortName)]) {
                        let value: string[] = queryParams[BookingSearchParameters.getIndexedParamName(shortName, index, propertyItem.shortName)];
                        if (typeof value === 'string') {
                            value = [value];
                        }
                        afidiumService[propertyItem.name] = value;
                    }
                } else if (propertyItem.type === 'date') {
                    const valueMissing: string = queryParams[BookingSearchParameters.getIndexedParamName(shortName, index, propertyItem.shortName, 'missing')];
                    const valueMin: string = queryParams[BookingSearchParameters.getIndexedParamName(shortName, index, propertyItem.shortName, 'min')];
                    const valueMax: string = queryParams[BookingSearchParameters.getIndexedParamName(shortName, index, propertyItem.shortName, 'max')];
                    const valueDate: IDateRange = {};
                    if (valueMissing) {
                        valueDate.missing = Boolean(valueMissing);
                    }
                    if (valueMin) {
                        valueDate.min = valueMin;
                    }
                    if (valueMax) {
                        valueDate.max = valueMax;
                    }
                    if (valueMin || valueMax || valueMissing) {
                        afidiumService[propertyItem.name] = valueDate;
                    }
                }
            });
            if (maxServiceIndex !== null) {
                allAfidiumServices.push(afidiumService as IAfidiumServicePatchedValue);
            }
        }
        if (allAfidiumServices.length === 0) {
            return undefined;
        }
        return allAfidiumServices;
    }

    /**
     * Extracts max index number when an array is serialized as query params in the form of :
     * <code>persons = [{firstName: "laurent", lastName: "voulzy"}, {firstName: "vanessa", lastName: "paradis"}]</code>
     * serialized as
     * <code>?pers.0.fn=laurent&pers.0.ln=voulzy&pers.1.fn=vanessa&pers.1.ln=paradis</code>
     * (here max index number would be 1)
     * @param queryParams query parameters to analyse
     * @param shortName prefix of parameters for serialized array
     */
    public static extractMaxIndexNumber(queryParams: IBookingSearchParametersURL, shortName: string): number {
        let maxServiceIndex: number = null;
        Object.keys(queryParams).forEach((paramKey: string) => {
            const paramKeyArray: string[] = paramKey.split('.');
            if (paramKeyArray.includes(shortName)) {
                const serviceIndex: number = Number(paramKeyArray[1]);
                if (!maxServiceIndex || serviceIndex > maxServiceIndex) {
                    maxServiceIndex = serviceIndex;
                }
            }
        });
        return maxServiceIndex;
    }

    private static getIndexedParamName(arrayShortName: string, index: number, propertyShortName: string, suffix: string = '') {
        return `${arrayShortName}.${index}.${propertyShortName}${suffix}`;
    }

    public clone(): BookingSearchParameters {
        return _cloneDeep(this);
    }

    public convertToUrlParameters(): IBookingSearchParametersURL {
        let urlParameters: IBookingSearchParametersURL = null;

        urlParameters = BookingSearchParameters.STRING_ARRAY_PROPERTIES
            .reduce((parameters: IBookingSearchParametersURL, config: IConfig): IBookingSearchParametersURL => {
                return SearchUtils.setArrayValueIfNotEmpty<IBookingSearchParametersURL>(parameters, this[config.name], config.shortName);
            }, urlParameters);

        urlParameters = BookingSearchParameters.STRING_PROPERTIES
            .reduce((parameters: IBookingSearchParametersURL, config: IConfig): IBookingSearchParametersURL => {
                return SearchUtils.setNumberValue<IBookingSearchParametersURL>(parameters, this[config.name], config.shortName);
            }, urlParameters);

        urlParameters = BookingSearchParameters.CODE_TEXT_PROPERTIES
            .reduce((parameters: IBookingSearchParametersURL, config: IConfig): IBookingSearchParametersURL => {
                return SearchUtils.setTextCodeValueIfNotEmpty<IBookingSearchParametersURL>(parameters, this[config.name], config.shortName);
            }, urlParameters);

        urlParameters = BookingSearchParameters.DATE_RANGE_PROPERTIES
            .reduce((parameters: IBookingSearchParametersURL, config: IConfig) => {
                return SearchUtils.setDateRangeValueIfNotEmpty<IBookingSearchParametersURL>(parameters, this[config.name], config.shortName);
            }, urlParameters);

        urlParameters = BookingSearchParameters.BOOLEAN_PROPERTIES
            .reduce((parameters: IBookingSearchParametersURL, config: IConfig) => {
                return SearchUtils.setValueIfNotEmpty<IBookingSearchParametersURL>(parameters, this[config.name], config.shortName);
            }, urlParameters);

        const afidiumServiceName: string = 'afidiumServices';
        urlParameters = SearchUtils.setFormArrayValueIfNotEmpty('afs', this[afidiumServiceName], urlParameters);

        urlParameters = SearchUtils.setValueIfNotEmpty<IBookingSearchParametersURL>(urlParameters, this.nbrecord, 'nbrecord');
        urlParameters = this.first === 0 ? urlParameters :
            SearchUtils.setValueIfNotEmpty<IBookingSearchParametersURL>(urlParameters, this.first, 'first');

        return urlParameters;
    }

    public clearValues(names: string[]): BookingSearchParameters {
        const splitValue: string[] = names[0].split(' ');
        const afidiumServiceName: string = 'afidiumServices';
        if (splitValue[1] === 'service') {
            this[afidiumServiceName].splice([splitValue[2]], 1);
        } else {
            names.forEach((name: string) => {
                this[name] = undefined;
            });
        }


        return this;
    }

}
